(($, Drupal) => {
  Drupal.behaviors.tabbedContent = {
    attach(context) {
      // Tab Content
      // paragraph--tabbed-content-tabs.html.twig
      const tabRows = $('[id^="tabbed-content-id"]', context);
      $.each(tabRows, function(){
        const tabNavs = $(this).find('.tabbed-content-tabs a');
        const contentPanes = $(this).find('.tab-pane');
        $.each(tabNavs, function(){
          $(this).click(function(e){
            e.preventDefault();
            const target = $(this).data("target");
            if (!$(this).hasClass('active')){
              tabNavs.removeClass('active');
              contentPanes.hide();
              $(this).addClass('active');
              $('#' + target).fadeIn(400);
            }
          });
        });
      });
    }
  }
})(jQuery, Drupal);
